import { empty } from '@sdk/helpers/misc/nullable';

const CUSTOM_COMMERCIAL_PROPERTIES = [
  'return_preference',
  'min_return',
  'max_return',
  'quota_preference',
  'credit_condition_plus',
  'include_financial_protection_insurance',
];

const CUSTOM_PRODUCT_OPTIONS_PROPERTIES = [
  'include_capitalization_bond',
  'include_asset_insurance',
  'include_personal_insurance',
];

function fuel(simulation) {
  let type = {};

  try {
    type = simulation.vehicle.fuel_type;
  } catch (err) { /* */ }

  if (!type || !type.credere_identifier) {
    try {
      type = simulation.vehicle.vehicle_model.fuel_type;
    } catch (err) { /* */ }
  }

  return type.credere_identifier;
}

function installment(condition, simulation, down) {
  const upfront = (empty(down) ? condition.down_payment : down) || 0;

  const json = {
    down_payment: upfront,
    financed_amount: simulation.assets_value - upfront,
    installments: condition.installments,
    products_options: {},
  };

  if (condition.bank && condition.bank.febraban_code) {
    json.bank_febraban_code = condition.bank.febraban_code;
  }

  CUSTOM_COMMERCIAL_PROPERTIES
    .filter(property => !empty(condition[property]))
    .forEach((property) => {
      json[property] = condition[property];
    });

  if (!['min', 'max'].includes(condition.return_preference)) {
    delete json.return_preference;
  }

  if (!['min', 'max'].includes(condition.quota_preference)) {
    delete json.quota_preference;
  }

  if (condition.products_options) {
    CUSTOM_PRODUCT_OPTIONS_PROPERTIES
      .filter(property => !empty(condition.products_options[property]))
      .forEach((property) => {
        json.products_options[property] = condition.products_options[property];
      });
  }

  return json;
}

function installments(simulation, down) {
  return simulation.conditions
    .filter(condition => !condition.suggestion_reason)
    .map(condition => installment(condition, simulation, down));
}

export default function payload(simulation, down) {
  const storeID = simulation.payload ? simulation.payload.store_id : undefined;
  const leadCPF = simulation.lead ? simulation.lead.cpf_cnpj : undefined;
  const value = simulation.assets_value;
  const documentation = (simulation.items || [])
    .reduce((v, i) => v + (i.type === 'documentation' ? i.value : 0), 0);
  const accessory = (simulation.items || [])
    .reduce((v, i) => v + (i.type === 'accessory' ? i.value : 0), 0);

  const json = {
    header_store_id: storeID,
    cpf_cnpj: leadCPF,

    simulation: {
      process_bank_suggested_conditions: true,

      payload: {
        store_id: storeID,
        origin: 'pwa',
      },

      seller_cpf: simulation.seller_cpf || (simulation.seller && simulation.seller.cpf),
      retrieve_lead: { cpf_cnpj: leadCPF },

      assets_value: value,
      accessory_value: accessory,
      documentation_value: documentation,

      vehicle: {
        vehicle_molicar_code: simulation.vehicle.vehicle_model.molicar_code,
        licensing_uf: simulation.vehicle.licensing_uf,
        licensing_city: simulation.vehicle.licensing_city,
        manufacture_year: simulation.vehicle.manufacture_year,
        model_year: simulation.vehicle.model_year,
        retrieve_fuel_type: fuel(simulation),
        asset_value: value,
        zero_km: simulation.vehicle.zero_km,
      },

      conditions: installments(simulation, down),
    },
  };

  if (simulation.bank_febraban_codes) {
    json.bank_febraban_codes = simulation.bank_febraban_codes;
  }

  return json;
}
